const NAME = "LOCATION_SETTINGS";

export default NAME;
